export default __webpack_public_path__ + "static/media/pexels-markus-winkler-4052198.d3bb5885.jpg";